import { useCallback } from "react";
import { useSaveOrderMutation } from "../mutations/useSaveOrder.mutation";
import { OrderInterface } from "../../../interfaces/orderInterface";

export const useSaveOrder = () => {
  const saveMutation = useSaveOrderMutation();

  const handleSave = useCallback(
    (values: OrderInterface, callback?: () => void) => {
      saveMutation.mutate(values, {
        onSuccess: (res) => {
          if (res.ok) callback?.();
        },
      });
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
